import React, { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

import { Dispatch } from 'redux';
import { configs } from '../../constants/configs/configs';
import Layout from './components/Layout';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { environmentSelector } from '../../selectors/commonSelectors';
import { fetchCurrentUserInfoDetails, fetchCurrentUserViewRef } from '../../actions/ridp/ridpActionCreators';
import endpoints from '../../constants/configs/endpoints';
import { IUserInfo } from './types/ridpTypes';

const RIDP = () => {
    const {
        routes: {
            RIDP_CALL_EXPERIAN,
            RIDP_UPLOAD_DOCUMENT,
            RIDP_TECHNICAL_ERROR,
            RIDP_VERIFICATION_COMPLETE,
            RIDP_VERIFICATION_REJECTED,
            RIDP_UPLOAD_DOCUMENT_PROCESS,
        },
    } = configs;
    const navigate = useNavigate();
    const location = useLocation();

    const environment = useAppSelector(environmentSelector);
    const viewRef = useAppSelector(state => state.ridp.viewRef);
    const currentUserInfo = useAppSelector(state => state.ridp.currentUserInfo) as IUserInfo;

    const dispatch: Dispatch<any> = useAppDispatch();
    const existingParams = new URLSearchParams(window.location.search);

    useEffect(() => {
        if (!viewRef) {
            dispatch(fetchCurrentUserViewRef(endpoints.RIDP_VIEWREF_ENDPOINT, environment));
        } else {
            dispatch(
                fetchCurrentUserInfoDetails(
                    endpoints.RIDP_CURRENT_USER_INFO_ENDPOINT.processReplacements({
                        viewRef,
                        ts: Date.now(),
                    }),
                    environment,
                ),
            );
        }
    }, [viewRef]);
    useEffect(() => {
        if (currentUserInfo) {
            if (currentUserInfo.ridpVerified === 'Y') {
                navigate(`${RIDP_VERIFICATION_COMPLETE}?${existingParams.toString()}`);
            } else if (currentUserInfo.ridpSource === 'MANUAL') {
                if (!Array.isArray(currentUserInfo.documentsUploaded) || currentUserInfo.documentsUploaded.length === 0) {
                    navigate(`${RIDP_UPLOAD_DOCUMENT}?${existingParams.toString()}`);
                } else {
                    const hasSubmitted = currentUserInfo.documentsUploaded.some(doc => doc.status === 'SUBMITTED');

                    if (hasSubmitted) {
                        navigate(`${RIDP_UPLOAD_DOCUMENT_PROCESS}?${existingParams.toString()}`);
                    } else if (currentUserInfo.documentsUploaded.some(doc => doc.status === 'REJECTED')) {
                        navigate(`${RIDP_VERIFICATION_REJECTED}?${existingParams.toString()}`);
                    } else {
                        navigate(`${RIDP_UPLOAD_DOCUMENT}?${existingParams.toString()}`);
                    }
                }
            } else {
                const isBlocked = currentUserInfo.isRidpRbaEnabled === true ? currentUserInfo.timePeriodBlock : currentUserInfo.sixteenHourBlock;
                const manualUploadRoutePaths = [
                    RIDP_UPLOAD_DOCUMENT,
                    RIDP_UPLOAD_DOCUMENT_PROCESS,
                    RIDP_VERIFICATION_REJECTED,
                ];
                const isOnManualUploadRoute = manualUploadRoutePaths.some(
                    routePath => location.pathname.includes(routePath),
                );
                if (isBlocked && !isOnManualUploadRoute) {
                    navigate(`${RIDP_TECHNICAL_ERROR}?${existingParams.toString()}`);
                } else if (currentUserInfo.ridpSource === 'FARS' || currentUserInfo.ridpSource === 'GETRECORD') {
                    navigate(`${RIDP_CALL_EXPERIAN}?${existingParams.toString()}`);
                }
            }
        }
    }, [currentUserInfo, location.pathname]);

    return currentUserInfo ? (
        <Layout>
            <Outlet />
        </Layout>
    ) : null;
};

export default RIDP;
